import { InAppBrowser } from "@ionic-native/in-app-browser";
import { Injectable } from "@angular/core";

@Injectable()
export class InappProvider {
    constructor(private inapp: InAppBrowser) {}

    open(url) {
        return this.inapp.create(url, "_system");
    }

    close(window) {
        window.close();
    }
}



// WEBPACK FOOTER //
// ./src/providers/inapp/inapp.ts